import { Box, IconButton, useTheme } from '@mui/material'
import { useRef, useState, useEffect } from 'react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const ScrollWrapper = ( { children, gap = 1, scrollAmount = 300, wrapperStyles = {}, edgeBaseColor } ) => {
    const scrollRef = useRef( null )
    const [showLeft, setShowLeft] = useState( false )
    const [showRight, setShowRight] = useState( false )
    const { palette, border, theme } = useTheme()

    const checkScroll = () => {
        if ( scrollRef.current ) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current
            setShowLeft( scrollLeft > 10 )
            setShowRight( scrollLeft < scrollWidth - clientWidth - 10 )
        }
    }

    useEffect( () => {
        checkScroll()
        window.addEventListener( 'resize', checkScroll )
        return () => {
            window.removeEventListener( 'resize', checkScroll )
        }
    }, [children] )

    const handleScroll = ( direction ) => {
        if ( scrollRef.current ) {
            const distance = direction === 'left' ? -scrollAmount : scrollAmount
            scrollRef.current.scrollBy( { left: distance, behavior: 'smooth' } )
        }
    }

    const btnStyles = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 20,
        bgcolor: theme === 'dark' ? palette.grey[700] : palette.grey[600],
        color: palette.common.white,
        boxShadow: 2,
        '&:hover': { bgcolor: palette.action.hover },
        display: { xs: 'none', md: 'inline-flex' }
    }

    return (
        <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
            {/* Left Button */}
            {showLeft && (
                <IconButton
                    size="small"
                    onClick={() => handleScroll( 'left' )}
                    sx={{ ...btnStyles, left: 5 }}
                >
                    <ChevronLeftIcon />
                </IconButton>
            )}

            {showLeft && <Box sx={{ position: "absolute", zIndex: 10, left: 0, top: 0, bottom: 0, width: "80px", background: `linear-gradient(to right, ${edgeBaseColor || palette.background.default}, transparent)` }} />}

            {/* Right Button */}
            {showRight && (
                <IconButton
                    size="small"
                    onClick={() => handleScroll( 'right' )}
                    sx={{ ...btnStyles, right: 5 }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            {showRight && <Box sx={{ position: "absolute", zIndex: 10, right: 0, top: 0, bottom: 0, width: "80px", background: `linear-gradient(to left, ${edgeBaseColor || palette.background.default}, transparent)` }} />}

            <Box
                ref={scrollRef}
                onScroll={checkScroll}
                sx={{
                    display: "flex",
                    gap: gap,
                    height: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    scrollBehavior: 'smooth',
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                    ...wrapperStyles
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export default ScrollWrapper